<template>
  <section id="screenshots">
    <div class="main-container">
      <div class="screenshots__wrapper">
        <div class="screenshot__item" @click="showModal(1)">
          <picture>
            <source
              type="image/webp"
              srcset="/static/img/geobeta/screenshots/thumbs/mini-dayz-2-1.webp"
            />
            <source
              type="image/jpeg"
              srcset="/static/img/geobeta/screenshots/thumbs/mini-dayz-2-1.jpg"
            />
            <img
              src="/static/img/geobeta/screenshots/thumbs/mini-dayz-2-1.jpg"
              alt=""
            />
          </picture>
        </div>
        <div class="screenshot__item" @click="showModal(2)">
          <picture>
            <source
              type="image/webp"
              srcset="/static/img/geobeta/screenshots/thumbs/mini-dayz-2-2.webp"
            />
            <source
              type="image/jpeg"
              srcset="/static/img/geobeta/screenshots/thumbs/mini-dayz-2-2.jpg"
            />
            <img
              src="/static/img/geobeta/screenshots/thumbs/mini-dayz-2-2.jpg"
              alt=""
            />
          </picture>
        </div>
        <div class="screenshot__item" @click="showModal(3)">
          <picture>
            <source
              type="image/webp"
              srcset="/static/img/geobeta/screenshots/thumbs/mini-dayz-2-3.webp"
            />
            <source
              type="image/jpeg"
              srcset="/static/img/geobeta/screenshots/thumbs/mini-dayz-2-3.jpg"
            />
            <img
              src="/static/img/geobeta/screenshots/thumbs/mini-dayz-2-3.jpg"
              alt=""
            />
          </picture>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    showModal(screenNum) {
      this.$emit("show-modal", screenNum);
    },
  },
};
</script>
<style lang="scss" scoped>
.screenshots__wrapper {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }

  .screenshot__item {
    flex: 1;
    max-width: 100%;
    margin: 15px 15px 0 15px;
    height: auto;
    cursor: pointer;
    img {
      border-radius: 10px;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
